"use client";

import {
  GTM_DEVELOPMENT_ID,
  GTM_PRODUCTION_ID,
  IS_PRODUCTION,
} from "@frontend/roz-sdk-core";
import type { ReactNode } from "react";
import {
  CookieBanner,
  GoogleTagManager,
  Listeners,
  MaintenanceBanner,
  SocialAuthTracker,
  Toaster,
} from "@/atoms/cross-cutting";
import { useShellControls } from "@/hooks-internal/useShellControls";
import { Modal, Sheet } from "@/overlays";

import { StandardFooter } from "./StandardFooter";
import { StandardHeader } from "./StandardHeader";

export interface StandardShellProps {
  children: ReactNode;
  searchEnabled?: boolean;
  cookieBannerEnabled?: boolean;
  maintenanceBannerEnabled?: boolean;
  gtmEnabled?: boolean;
  footerContainerId?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
}

export const StandardShell = ({
  children,
  searchEnabled = false,
  cookieBannerEnabled = true,
  maintenanceBannerEnabled = false,
  gtmEnabled = true,
  footerContainerId,
  hideHeader = false,
  hideFooter = false,
}: StandardShellProps) => {
  const { headerVisible, footerVisible } = useShellControls();

  return (
    <>
      {headerVisible && !hideHeader ? (
        <StandardHeader searchEnabled={searchEnabled} />
      ) : null}
      {/* ВРЕМЕННЫЙ фикс (Phase 4). flex-1 прижимает футер к низу, но ТОЛЬКО
          когда shell лежит во flex-колонке с min-height (cms: `flex min-h-svh
          flex-col`). Вне flex-контекста (front, свой min-height-контейнер) класс
          инертен. Контракт неявный — правильный фикс (shell сам владеет
          колонкой) вынесен в
          docs/superpowers/plans/2026-07-08-sdk-phase5-shell-sticky-footer.md */}
      <div className="sdkui:flex sdkui:min-h-0 sdkui:flex-1 sdkui:flex-col">
        {children}
      </div>
      {footerVisible && !hideFooter ? (
        <StandardFooter containerId={footerContainerId} />
      ) : null}
      <Sheet />
      <Modal />
      <CookieBanner enabled={cookieBannerEnabled} />
      {maintenanceBannerEnabled ? <MaintenanceBanner /> : null}
      <Listeners />
      <SocialAuthTracker />
      <Toaster />
      {gtmEnabled ? (
        <GoogleTagManager
          gtmId={IS_PRODUCTION ? GTM_PRODUCTION_ID : GTM_DEVELOPMENT_ID}
        />
      ) : null}
    </>
  );
};
